export const SET_LIBRARY_FILTER = 'SET_LIBRARY_FILTER';
export const SET_BOARD_FILTER = 'SET_BOARD_FILTER';
export const SET_SIDEBAR_FILTER = 'SET_SIDEBAR_FILTER';
export const SET_PROJECTS_FILTER = 'SET_PROJECTS_FILTER';
